import styled from 'styled-components';
import { Alert } from '@sainsburys-tech/bolt';
var StoreDetailsContainer = styled.div.withConfig({
  displayName: "StoreDetailsstyles__StoreDetailsContainer",
  componentId: "sc-1ayhydt-0"
})(["width:100%;height:100%;position:absolute;bottom:0;top:", ";background:", ";left:0;z-index:4;transition:0.4s ease-in;transform-style:preserve-3d;backface-visibility:hidden;overflow-y:scroll;padding-bottom:", ";"], function (props) {
  return props.store ? 0 : '100%';
}, function (props) {
  return props.theme.color.monochrome.white;
}, function (props) {
  return props.store && props.store.clickandcollect ? '20px' : 0;
});
var StoreContent = styled.div.withConfig({
  displayName: "StoreDetailsstyles__StoreContent",
  componentId: "sc-1ayhydt-1"
})(["padding:15px;padding-bottom:0;"]);
var StoreDistance = styled.p.withConfig({
  displayName: "StoreDetailsstyles__StoreDistance",
  componentId: "sc-1ayhydt-2"
})(["color:", ";padding-bottom:20px;@media (min-width:", "){display:inline-block;}"], function (props) {
  return props.theme.color.monochrome.darker;
}, function (props) {
  return props.theme.size.breakpoint['min-width'].sm;
});
var StoreAlert = styled(Alert).withConfig({
  displayName: "StoreDetailsstyles__StoreAlert",
  componentId: "sc-1ayhydt-3"
})(["margin-bottom:20px;"]);
var StoreRow = styled.div.withConfig({
  displayName: "StoreDetailsstyles__StoreRow",
  componentId: "sc-1ayhydt-4"
})(["position:relative;margin:0 -15px;"]);
var StoreDivider = styled.span.withConfig({
  displayName: "StoreDetailsstyles__StoreDivider",
  componentId: "sc-1ayhydt-5"
})(["display:block;height:100%;border-right:1px solid ", ";position:absolute;left:0;right:0;margin:auto;width:0;"], function (props) {
  return props.theme.color.monochrome.light;
});
var StoreInfo = styled.p.withConfig({
  displayName: "StoreDetailsstyles__StoreInfo",
  componentId: "sc-1ayhydt-6"
})(["color:", ";margin-bottom:10px;"], function (props) {
  return props.theme.color.monochrome.darker;
});
var StoreInfoTitle = styled.span.withConfig({
  displayName: "StoreDetailsstyles__StoreInfoTitle",
  componentId: "sc-1ayhydt-7"
})(["font-weight:800;display:inline-block;color:", ";@media (min-width:", "){width:100px;}"], function (props) {
  return props.theme.color.monochrome.darker;
}, function (props) {
  return props.theme.size.breakpoint['min-width'].sm;
});
var StoreCollectionPointText = styled.span.withConfig({
  displayName: "StoreDetailsstyles__StoreCollectionPointText",
  componentId: "sc-1ayhydt-8"
})(["display:inline-block;&::first-letter{text-transform:uppercase;}"]);
var StoreActions = styled.div.withConfig({
  displayName: "StoreDetailsstyles__StoreActions",
  componentId: "sc-1ayhydt-9"
})(["padding:50px 0 15px;display:flex;justify-content:flex-end;"]);
var HideButton = styled.button.withConfig({
  displayName: "StoreDetailsstyles__HideButton",
  componentId: "sc-1ayhydt-10"
})(["color:", ";background:", ";border:0;display:block;font-weight:bold;font-size:1rem;margin:5px;text-align:right;width:calc(100% - 10px);padding:15px;:hover,:active{color:", ";background:", ";}"], function (props) {
  return props.theme.color.palette['brand-1'];
}, function (props) {
  return props.theme.color.monochrome.white;
}, function (props) {
  return props.theme.color.palette['brand-1'];
}, function (props) {
  return props.theme.color.monochrome.white;
});
export { StoreDetailsContainer, StoreContent, StoreDistance, StoreAlert, StoreRow, StoreDivider, StoreInfo, StoreInfoTitle, StoreCollectionPointText, StoreActions, HideButton };